<template>
  <div 
    v-if="active"
    id="calculation-overview-modal"
    :class="{'is-active': active}"
    class="ec-modal ec-calculation-overview-modal is-fullscreen"
    @click.self="closeModal">
    <div 
      v-show="!loading"
      class="ec-modal-main is-loading animated fadeIn blue-border">
      <a 
        href="#" 
        class="close-icon modal-close" 
        @click.prevent="closeModal"/>
      <div class="ec-modal-headline is-big">{{ $t('calc_overview.overview_headline') }}</div>
      <div class="ec-modal-subheadline">
        <span 
          :class="{'font-color-red': !$store.isCalculationSaved}"
          class="ec-modal-subheadline-box"
          @click="changeCalculationName">
          {{ ($store.isCalculationSaved) ? $store.calculationName : $t('calc_overview.not_saved') }}
        </span>
      </div>
      <div class="pdf-wrapper">
        <button
          v-if="!$store.isCalculationSaved"
          class="btn is-darkblue create-pdf-btn"
          @click="changeCalculationName">{{ $t('calc_overview.save') }}</button>
        <a 
          :href="''+$store.public_id+'/pdf/'" 
          class="btn is-blue create-pdf-btn" 
          @click.prevent="generateAndDownload($event)">{{ $t('calc_overview.create_pdf') }}</a>
      </div>
      <div class="calculation-overview-wrapper">
        <div 
          v-show="!loading" 
          class="left-table">
          <table class="striped preset">
            <caption>{{ $t('calc_overview.facts') }}</caption>
            <tbody>
              <tr 
                v-for="fact in facts" 
                :key="fact.key">
                <td 
                  v-if="fact.question_bind" 
                  :data-label="$t('calc_overview.fact')">
                  <a 
                    href="#" 
                    @click.prevent="jumpTo(fact.question_bind)">{{ fact.label }}</a>
                </td>
                <td 
                  v-if="!fact.question_bind" 
                  :data-label="$t('calc_overview.fact')">{{ fact.label }}</td>
                <td 
                  :data-label="$t('calc_overview.answer')" 
                  v-html="fact.output"/>
              </tr>
            </tbody>
          </table>
          <div class="jump-to-help-text">{{ $t('calc_overview.jump_to_text') }}</div>
        </div>
        <div 
          v-show="!loading" 
          class="right-table">
          <table class="result-table">
            <caption>{{ $t('calc_overview.calculation') }}</caption>
            <tbody>
              <tr 
                v-for="result in calculation.results" 
                :key="result.key">
                <td data-label="Result">{{ result.label }}</td>
                <td 
                  class="result-value" 
                  data-label="Value">{{ result.calculated | numberFormater }} EUR
                </td>
              </tr>
              <tr 
                v-for="result in calculation.customResults" 
                :key="result.key">
                <td data-label="Result">{{ result.label }}</td>
                <td 
                  class="result-value" 
                  data-label="Value">{{ result.calculated | numberFormater }} EUR
                </td>
              </tr>
              <tr 
                v-show="calculation.surcharges.length"
                class="subtotal-row">
                <td colspan="2">
                  {{ $t('calc_overview.subtotal') }}: <span class="result-value">{{ calculation.subtotal | numberFormater }} EUR</span>
                </td>
              </tr>
              <tr 
                v-for="result in calculation.surcharges" 
                :key="result.key">
                <td data-label="Result">{{ result.label }}</td>
                <td 
                  class="result-value" 
                  data-label="Value">{{ result.calculated | numberFormater }} EUR</td>
              </tr>
            </tbody>
            <tr class="result-row-parent">
              <td 
                :class="{'first-row': calculation.subtotal === 0}"
                class="result-row" 
                colspan="2">
                {{ $t('calc_overview.total') }}: <span class="result-value">{{ calculation.total | numberFormater }} EUR</span>
              </td>
            </tr>
          </table>
          <div class="inkl-umsatz">{{ $t('calc_overview.inkl') }}</div>
        </div>
      </div>
      <div 
        v-show="loading" 
        class="ec-modal-loader"/>
    </div>
    <div 
      v-show="jumperWarning.active" 
      class="ec-modal-main ec-jumper-warning is-danger">
      <a 
      href="#" 
        class="close-icon modal-close" 
        @click.stop="jumperWarning.active = false"/>
      <div class="ec-modal-headline">{{ $t('calc_overview.warning') }}</div>
      <div class="ec-modal-text">
        {{ $t('calc_overview.jump_to_position') }}
      </div>
      <div class="ec-modal-btn-wrapper">
        <button 
          id="ec-modal-variable-cancel" 
          class="ec-modal-btn-cancel btn is-grey modal-close" 
          @click.stop="jumperWarning.active = false">{{ $t('calc_overview.cancel') }}
        </button>
        <button 
          id="ec-modal-variable-ok" 
          class="ec-modal-btn-ok btn is-red" 
          @click="jumpToOk()">{{ $t('calc_overview.next') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
  import Modal from './Modal.mixin.vue'
  import { loading as pageLoader } from '../core/page-loader'
  import { placeholderFormater, redirect } from '../utility'

  export default {
      mixins: [Modal],
      data: function () {
          return {
              name: 'Meine Kalkulation',
              calculation: null,
              calculationId: null,
              facts: [],
              loading: false,
              jumperWarning: {
                  active: false,
                  jumpTo: null
              }
          }
      },
      watch: {
          active: function (value) {
              if (value) {
                  this.loading = true
                  axios.get(this.$store.axiosBase + 'facts').then((response) => {
                      this.facts = response.data
                      this.loading = false

                      this.$nextTick(function() {
                          $('.placeholder:not(.live-formula)', '.left-table').each((key, el) => {
                              placeholderFormater(el)
                          })
                      })
                  })
              } else {
                  this.jumperWarning.active = false
                  this.facts = []
              }
          },
          loading: function (value) {
              pageLoader(value)
          }
      },
      created() {
          this.calculationId = ActiveCalculationId
          this.$event.$on('show-calculation-overview-modal', (calculation) => {
              this.calculation = calculation
              this.active = true
              this.$store.modalOpen = true
          })
      },
      computed: {
          readOnly() {
              return this.$store.readOnlyCode || false
          }
      },
      methods: {
          jumpTo(to) {
            to = '/'+this.$store.axiosBase+"jumpTo/question/"+to+'?sessionmark=true&readonly='+this.readOnly
 
            // if(this.$store.readOnlyCode) {
            //   to = to + '?readonly='+this.$store.readOnlyCode
            // }

            redirect(to)
          },
          jumpToOk() {
              redirect("calculation/jumpTo/question/"+this.jumperWarning.jumpTo)
          },
          generateAndDownload() {
              if(AuthCheck) {
                  if(!this.$store.isCalculationSaved) {
                    this.$event.$emit('change-calculation-name', {
                      text: this.$t('calc_overview.before_pdf')
                    })
                    return;
                  }

                  pageLoader(true)

                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                      event: 'pdfCreated',
                  });

                  redirect(this.$store.publicId+'/pdf', true)

                  setTimeout(() => {
                      pageLoader(false)
                  }, 5000)
              } else {
                  this.$event.$emit('login-first')
              }
          },
          changeCalculationName() {
              this.$event.$emit('change-calculation-name')
          },
      },
  }
</script>